import React, { useState, useContext, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Home, User, LogOut, Menu, X, Bell } from "lucide-react";
import SuryaLogoMain from "../../assets/images/Jobmongo-logo.png";
import DummyImg from "../../assets/images/user-dummy-img.jpg";
import LogoutConfirmModal from "./LogoutConfirmModal";
import { AuthContext } from "../../Context/ContextFunctions";
import ProfileModel from "./ProfileModel";
import { FaChartBar } from "react-icons/fa";
import { HiUserGroup } from "react-icons/hi";

import MyTeamModal from "./MyTeamModal";
const Navbar = () => {
  const dropdownRef = useRef(null);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [userProfile, setUserProfile] = useState(false);
  const [userProfileOpenPopup, setUserProfileOpenPopup] = useState(false);
  const [myTeamModalOpenPopup, setMyTeamModalOpenPopup] = useState(false);

  const [showConfirmationModal, setConfirmationModal] = useState(false);
  const [isOfficeToolsOpen, setOfficeToolOpen] = useState(false);
  const navigate = useNavigate();
  const {
    authDetails,
    defaultAccess,
    unSeenCount,
    GetUserNotificationListData,
  } = useContext(AuthContext);
  const location = useLocation(); // Get the current route
  const menuRef = useRef(null);
  const clientKeyID = localStorage.getItem("clientKeyID");
  const menuItems = [
    { name: "Dashboard", path: "/", activePaths: ["/"], access: true },
    {
      name: "Clients",
      path: "/client",
      activePaths: clientKeyID
        ? ["/client", "/addUpdateClient", "/viewClient", "/addUpdateJob"]
        : ["/client", "/addUpdateClient", "/viewClient"],
      access: defaultAccess.ClientCanView,
    },
    {
      name: "Jobs",
      path: "/job",
      activePaths: clientKeyID ? ["/job"] : ["/job", "/addUpdateJob"],
      access: defaultAccess.JobCanView,
    },
    {
      name: "Users",
      path: "/staff",
      activePaths: ["/staff", "/viewStaff", "/viewLog"],
      access: defaultAccess.UserCanView,
    },
    // { name: "Visitors", path: "/visitors", activePaths: ["/visitors"] },
    // { name: "Campaign", path: "/addUpdateCampaign", activePaths: ["/addUpdateCampaign"] },
    // {
    //   name: "Leave",
    //   path: "/LeaveManagement",
    //   activePaths: ["/LeaveManagement"],
    // },
    // {
    //   name: "Documents",
    //   path: "/paperWork",
    //   activePaths: ["/paperWork"],
    // },

    {
      name: "Reports",
      path: "/report",
      activePaths: ["/report"],
      access: defaultAccess.ClientReportsCanView,
    },
    {
      name: "Subscriptions",
      path: "/subscriptions",
      activePaths: ["/subscriptions"],
      access: defaultAccess.SubscriptionCanView,
    },

    {
      name: "Office Automation",
      path: "/Office",
      activePaths: [
        "/knowledge-base",
        "/LeaveManagement",
        "/visitors",
        "/campaign",
        "/addUpdateCampaign",
        "/paperWork",
        "/reminder",
        "/emailTemplate",
        "/addUpdateTemplate",
      ],
      subMenu: [
        {
          name: "Knowlegde Base",
          path: "/knowledge-base",
          access: defaultAccess.KnowledgeBaseCanView,
        },
        {
          name: "Leave",
          path: "/LeaveManagement",
          access: defaultAccess.LeaveCanView,
        },
        {
          name: "Visitors",
          path: "/visitors",
          access: defaultAccess.VisitorCanView,
        },
        {
          name: "Campaign",
          path: "/campaign",
          access: defaultAccess.CampaignCanView,
        },
        {
          name: "Documents Manager",
          path: "/paperWork",
          access: defaultAccess.DocumentManagerCanView,
        },
        {
          name: "Reminder",
          path: "/reminder",
          access: defaultAccess.ReminderCanView,
        },
        {
          name: "Email Template",
          path: "/emailTemplate",
          access: defaultAccess.ConfigureEmailTemplatesCanView,
        },
      ],
    },
    {
      name: "Configure",
      path: "/setting",
      activePaths: ["/setting", "/addupdateChecklist", "/service-job-type"],
      access: defaultAccess?.Config,
    },
  ];

  useEffect(() => {
    GetUserNotificationListData(1);
  }, [location.pathname]);
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setUserProfile(false);
      }
    }

    if (userProfile) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [userProfile]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMobileMenu(false);
      }
    };

    if (mobileMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [mobileMenu]);
  const handleLogout = () => {
    setConfirmationModal(true);
  };

  const onConfirmLogout = () => {
    localStorage.clear();
    navigate("/login");
    window.location.reload();
    setConfirmationModal(false);
  };

  return (
    <>
      <nav className="bg-[#ECF6FF] shadow-md">
        <div className="mx-auto px-4 sm:px-6 lg:px-8">
          <div
            className="flex justify-between items-center h-16"
            style={{ margin: "5px" }}
          >
            <div className="flex items-center space-x-4">
              <div>
                <img
                  className="w-12 h-12 rounded cursor-pointer"
                  onClick={() => navigate("/")}
                  src={SuryaLogoMain}
                  alt="Company Logo"
                />
              </div>
              <div className="hidden sm:flex flex-col">
                <span className="font-bold text-14 mb-2">
                  {authDetails?.companyName}
                </span>
                <div className="flex space-x-4 mb-2">
                  {menuItems
                    .filter((item) => item.access !== false) // ✅ filter out inaccessible top-level items
                    .map((item, index) => (
                      <div key={index} className="relative">
                        {item.subMenu ? (
                          // Check if at least one subItem has access
                          item.subMenu.some(
                            (subItem) => subItem.access !== false
                          ) && (
                            <div
                              className="relative -mt-1"
                              onMouseEnter={() => setOfficeToolOpen(index)}
                              onMouseLeave={() => setOfficeToolOpen(null)}
                            >
                              <button
                                className={`text-12 transition px-3 py-2 rounded-md flex items-center relative ${item.activePaths.includes(location.pathname)
                                  ? "text-white bg-[#E86B1B]"
                                  : "text-[#135EA0] hover:text-blue-700"
                                  }`}
                              >
                                {item.name}
                                <svg
                                  className="ml-1 w-4 h-4"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M19 9l-7 7-7-7"
                                  ></path>
                                </svg>
                              </button>
                              {isOfficeToolsOpen === index && (
                                <div className="text-12 absolute left-0 top-[calc(100%-2px)] w-48 bg-white shadow-lg rounded-md z-50 border border-gray-200">
                                  {item.subMenu
                                    .filter(
                                      (subItem) => subItem.access !== false
                                    )
                                    .map((subItem, subIndex) => (
                                      <Link
                                        key={subIndex}
                                        to={subItem.path}
                                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                        onClick={() => setOfficeToolOpen(null)}
                                      >
                                        {subItem.name}
                                      </Link>
                                    ))}
                                </div>
                              )}
                            </div>
                          )
                        ) : (
                          <Link
                            to={item.path}
                            className={`text-12 transition px-3 py-2 rounded-md relative ${item.activePaths.includes(location.pathname)
                              ? "text-white bg-[#E86B1B]"
                              : "text-[#135EA0] hover:text-blue-700"
                              }`}
                          >
                            {item.name}
                          </Link>
                        )}
                      </div>
                    ))}
                </div>
              </div>
            </div>

            <div className="sm:hidden">
              <span className="font-bold text-14 mb-2">
                {authDetails?.companyName}
              </span>
            </div>

            <button
              className="sm:hidden p-2 focus:outline-none"
              onClick={() => setMobileMenu(!mobileMenu)}
            >
              <svg
                className="w-6 h-6 text-gray-700"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                ></path>
              </svg>
            </button>
            <div className="flex items-center space-x-4 relative">
              {/* Notification Bell */}
              <button
                onClick={() => {
                  if (mobileMenu) {
                    setMobileMenu(!mobileMenu);
                  }
                  navigate("/notification");
                }}
                className="relative focus:outline-none"
              >
                <Bell size={26} className="text-gray-700 hover:text-gray-900" />
                {unSeenCount > 0 && (
                  <span className="absolute -top-[0.55rem] -right-1 bg-[#E86B1B] text-white text-xs w-5 h-5 flex items-center justify-center rounded-full">
                    {unSeenCount}
                  </span>
                )}
              </button>

              {/* Profile Section */}
              <div className="relative">
                <button
                  onClick={() => {
                    if (mobileMenu) {
                      setMobileMenu(!mobileMenu);
                    }
                    setUserProfile(!userProfile);
                  }}
                  className="focus:outline-none"
                >
                  <img
                    className="w-12 h-12 rounded-full"
                    src={DummyImg}
                    alt="User"
                    style={{
                      marginLeft: "40px",
                      marginBottom: "-6px",
                      marginTop: "9px",
                    }}
                  />
                  <p className="px-4 py-2 font-bold text-12">
                    Hello, {authDetails?.firstName}
                  </p>
                </button>

                {/* Dropdown Menu */}
                {userProfile && (
                  <div
                    ref={dropdownRef}
                    className="z-10 text-12 absolute right-0 mt-2 w-60 bg-white rounded-md shadow-lg top-[3rem] ring-1 ring-gray-300"
                  >
                    <p className="px-4 py-2 font-bold text-12">
                      Hello, {authDetails?.firstName}
                    </p>
                    <Link
                      to="/profile-details"
                      onClick={() => setUserProfile(!userProfile)}
                      className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-200"
                    >
                      <User size={16} className="mr-2" /> Profile
                    </Link>

                    <Link
                      to="/Usage"
                      className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-200"
                      onClick={() => setUserProfile(false)}
                    >
                      <FaChartBar size={16} className="mr-2" /> Usage
                    </Link>
                    <Link
                      className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-200"
                      onClick={() => setMyTeamModalOpenPopup(true)}
                    >
                      <HiUserGroup size={16} className="mr-2" /> My Team
                    </Link>
                    <button
                      className="flex w-full items-center px-4 py-2 text-gray-700 hover:bg-gray-200"
                      onClick={handleLogout}
                    >
                      <LogOut size={16} className="mr-2" /> Logout
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {mobileMenu && (
          <div ref={menuRef} className="sm:hidden bg-white shadow-md">
            <div className="flex flex-col space-y-2 p-4">
              {menuItems
                .filter((item) => item.access !== false) // Filter out inaccessible main items
                .map((item, index) => {
                  // Check if the item has subMenu with at least one accessible item
                  const hasAccessibleSubMenu =
                    item.subMenu &&
                    item.subMenu.some((subItem) => subItem.access !== false);

                  return (
                    <div key={index}>
                      {hasAccessibleSubMenu ? (
                        <div>
                          <button
                            onClick={() =>
                              setOfficeToolOpen(
                                isOfficeToolsOpen === index ? null : index
                              )
                            }
                            className={`block text-12 rounded-md px-3 py-2 flex justify-between w-full ${item.activePaths.includes(location.pathname)
                              ? "text-white bg-[#E86B1B]"
                              : "text-[#135EA0] hover:bg-blue-200"
                              }`}
                          >
                            {item.name}
                            <svg
                              className={`w-4 h-4 transform ${isOfficeToolsOpen === index ? "rotate-180" : ""
                                }`}
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M19 9l-7 7-7-7"
                              ></path>
                            </svg>
                          </button>
                          {isOfficeToolsOpen === index && (
                            <div className="text-12 ml-4 mt-1 space-y-1">
                              {item.subMenu
                                .filter((subItem) => subItem.access !== false) // Only show allowed sub-items
                                .map((subItem, subIndex) => (
                                  <Link
                                    key={subIndex}
                                    to={subItem.path}
                                    className="block text-12 px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
                                    onClick={() => setMobileMenu(false)}
                                  >
                                    {subItem.name}
                                  </Link>
                                ))}
                            </div>
                          )}
                        </div>
                      ) : (
                        <Link
                          to={item.path}
                          className={`block text-12 rounded-md px-3 py-2 ${location.pathname === item.path
                            ? "text-white bg-[#E86B1B]"
                            : "text-[#135EA0] hover:bg-blue-200"
                            }`}
                          onClick={() => setMobileMenu(false)}
                        >
                          {item.name}
                        </Link>
                      )}
                    </div>
                  );
                })}
            </div>
          </div>
        )}
      </nav>

      {userProfileOpenPopup && (
        <ProfileModel
          isOpen={userProfileOpenPopup}
          onClose={() => setUserProfileOpenPopup(false)}
        />
      )}

      {myTeamModalOpenPopup && (
        <MyTeamModal
          isOpen={myTeamModalOpenPopup}
          onClose={() => setMyTeamModalOpenPopup(false)}
        />
      )}
      {/* Logout Confirmation Modal */}
      {showConfirmationModal && (
        <LogoutConfirmModal
          show={showConfirmationModal}
          onHide={() => setConfirmationModal(false)}
          onConfirm={onConfirmLogout}
        />
      )}
    </>
  );
};

export default Navbar;
